export default "__VITE_ASSET__mMil40xm3k7Yw94UkGtPYw__"